import axiosInstance, {
  getUserDetails,
  isSuperUser,
} from "../components/content/axiosConfig";

/** Ponds for dropdowns — super admin sees all ponds; legacy paths kept for shared components. */
export async function fetchPondsForCurrentUser(userDetails) {
  const u = userDetails || getUserDetails();

  if (isSuperUser(u)) {
    const response = await axiosInstance.get("api/Pond/GetAllPonds", {
      params: { search: "", limit: 100 },
    });
    const body = response.data;
    return Array.isArray(body) ? body : body?.data ?? [];
  }

  const sessionFisherID = u?.FisherID;
  if (sessionFisherID != null && sessionFisherID !== "") {
    const response = await axiosInstance.get(`api/Pond/GetAllPond/${sessionFisherID}`);
    const body = response.data;
    return Array.isArray(body) ? body : body?.data ?? [];
  }

  return [];
}

export function shouldShowPondOwnerInDropdown(userDetails) {
  const u = userDetails || getUserDetails();
  return isSuperUser(u);
}

export function mapPondsToSelectOptions(ponds, userDetails = getUserDetails()) {
  const showOwner = shouldShowPondOwnerInDropdown(userDetails);
  return (ponds || []).map((pond) => ({
    label:
      showOwner && pond.FisherName
        ? `${pond.Name} (${pond.FisherName})`
        : pond.Name,
    value: pond.id,
    fisherID: pond.FisherID,
  }));
}

export function resolveScopedFisherID(userDetails, ...sources) {
  if (userDetails?.FisherID != null && userDetails.FisherID !== "") {
    return userDetails.FisherID;
  }
  for (const src of sources) {
    if (src?.FisherID != null && src.FisherID !== "") return src.FisherID;
    if (src?.fisherID != null && src.fisherID !== "") return src.fisherID;
  }
  return null;
}

export function optionalFisherQueryParam(fisherId) {
  if (fisherId == null || fisherId === "") return {};
  return { FisherID: fisherId };
}
